// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__3JkgK","error":"input_error__1MFJV","correct":"input_correct__2zKWe"};